const nl = {
    _name: 'Nederlands',
    _flag: '🇳🇱',
    // Nav
    'nav.dashboard': 'Dashboard',
    'nav.pos': 'Kassa',
    'nav.calcul': 'Prijsberekening',
    'nav.devis': 'Offertes / Facturen',
    'nav.devisDeplacement': 'Offertes verplaatsing',
    'nav.commandes': 'Bestellingen',
    'nav.addDevice': 'Toestel toevoegen',
    'nav.reparations': 'Reparaties',
    'nav.clients': 'Klanten',
    'nav.stock': 'Voorraad',
    'nav.addStock': 'Voorraad toevoegen',
    'nav.etiquettes': 'Etiketten',
    'nav.users': 'Gebruikers',
    'nav.clientPwd': 'Wachtwoorden klanten',
    'nav.boutiqueOrders': 'Winkelbestellingen',
    'nav.caisseHistory': 'Kassageschiedenis',
    'nav.database': 'Database',
    'nav.historique': 'Geschiedenis',
    'nav.paiements': 'Online betalingen',
    'nav.chatClients': 'Chat klanten',
    'nav.chat': 'Berichten',
    'nav.notes': 'Notities',
    'nav.logout': 'Uitloggen',
    'nav.quit': 'Afsluiten',
    'nav.admin': 'Beheer',
    'nav.navigation': 'Navigatie',
    'nav.b2b': 'B2B-beheer',
    'nav.b2bPayments': 'B2B-betalingen',
    'nav.brandsModels': 'Merken & Modellen',
    // Common
    'common.save': 'Opslaan',
    'common.cancel': 'Annuleren',
    'common.delete': 'Verwijderen',
    'common.edit': 'Bewerken',
    'common.search': 'Zoeken',
    'common.add': 'Toevoegen',
    'common.close': 'Sluiten',
    'common.confirm': 'Bevestigen',
    'common.loading': 'Laden...',
    'common.noData': 'Geen gegevens',
    'common.actions': 'Acties',
    'common.status': 'Status',
    'common.date': 'Datum',
    'common.total': 'Totaal',
    'common.print': 'Afdrukken',
    'common.yes': 'Ja',
    'common.no': 'Nee',
    'common.back': 'Terug',
    'common.next': 'Volgende',
    'common.validate': 'Valideren',
    'common.ref': 'Referentie',
    'common.client': 'Klant',
    'common.phone': 'Telefoon',
    'common.email': 'E-mail',
    'common.price': 'Prijs',
    'common.quantity': 'Hoeveelheid',
    'common.amount': 'Bedrag',
    'common.send': 'Versturen',
    'common.download': 'Downloaden',
    'common.export': 'Exporteren',
    'common.refresh': 'Vernieuwen',
    'common.filter': 'Filteren',
    'common.all': 'Alles',
    'common.name': 'Naam',
    'common.address': 'Adres',
    'common.description': 'Beschrijving',
    'common.payment': 'Betaling',
    'common.paid': 'Betaald',
    'common.pending': 'In afwachting',
    'common.accepted': 'Geaccepteerd',
    'common.refused': 'Geweigerd',
    // Layout
    'layout.panel': 'Beheerpaneel',
    // POS
    'pos.title': 'Kassa',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Product zoeken (ref, naam, barcode)...',
    'pos.outOfStock': 'Niet op voorraad',
    'pos.article': 'Artikel',
    'pos.unitPrice': 'Eenheidsprijs',
    'pos.qty': 'Aantal',
    'pos.emptyCart': 'Winkelwagen leeg',
    'pos.checkout': 'Afrekenen',
    'pos.clientOptional': 'Klant (optioneel)',
    'pos.discount': 'Korting',
    'pos.subtotal': 'Subtotaal',
    'pos.validateSale': 'Verkoop bevestigen',
    'pos.paymentMode': 'Betaalmethode',
    'pos.choosePayment': 'Kies de betaalmethode:',
    'pos.cash': 'Contant',
    'pos.card': 'Bankkaart',
    'pos.mixed': 'Gemengd',
    'pos.totalToCollect': 'Te innen totaal',
    'pos.change': 'Wisselgeld',
    'pos.confirmPayment': 'Betaling bevestigen',
    'pos.validating': 'Bevestiging...',
    'pos.lastTicket': 'Laatste bon',
    'pos.caisseClosed': 'De kassa is gesloten. Open deze via het Dashboard om verkopen te doen.',
    'pos.insufficientCash': 'Onvoldoende contant bedrag',
    'pos.insufficientCard': 'Onvoldoende kaartbedrag',
    'pos.mixedMustEqual': 'De gemengde betaling moet gelijk zijn aan het totaal',
    'pos.emptyCartAlert': 'Winkelwagen leeg',
    'pos.selectPayment': 'Kies een betaalmethode',
    'pos.saleValidated': 'Verkoop bevestigd!',
    'pos.adminOverride': 'Administratorgoedkeuring',
    'pos.outOfStockProduct': 'Product niet op voorraad',
    'pos.adminId': 'Admin-ID',
    'pos.adminCode': 'Admin-code',
    'pos.manualAdd': 'Artikel handmatig toevoegen',
    'pos.designation': 'Aanduiding',
    'pos.stockInsufficient': 'Onvoldoende voorraad',
    // Devis
    'devis.title': 'Offertes & Facturen',
    'devis.subtitle': 'Documenten uit de prijsberekening (omzetbaar naar bestelling).',
    'devis.noDoc': 'Geen documenten gevonden',
    'devis.type': 'Type',
    'devis.convertConfirm': 'Deze offerte omzetten naar bestelling?',
    'devis.orderCreated': 'Bestelling aangemaakt',
    'devis.deleteConfirm': 'Dit document verwijderen?',
    'devis.deleted': 'Document verwijderd',
    // Devis Déplacement
    'devDep.title': 'Offertes verplaatsing',
    'devDep.subtitle': 'Beheer van offertes voor reparaties ter plaatse',
    'devDep.new': 'Nieuwe offerte',
    'devDep.edit': 'Offerte bewerken',
    'devDep.clientName': 'Klantnaam',
    'devDep.clientPhone': 'Telefoon',
    'devDep.clientEmail': 'E-mail',
    'devDep.clientAddress': 'Adres',
    'devDep.repairDesc': 'Reparatiebeschrijving',
    'devDep.lines': 'Offerteregels',
    'devDep.addLine': 'Toevoegen',
    'devDep.travelFee': 'Verplaatsingskosten',
    'devDep.sendByEmail': 'Per e-mail versturen',
    'devDep.sending': 'Versturen...',
    'devDep.pdfDevis': 'PDF Offerte',
    'devDep.pdfBon': 'PDF Bestelling',
    'devDep.pdfFacture': 'PDF Factuur',
    'devDep.searchPlaceholder': 'Zoek op ref, naam, e-mail...',
    'devDep.allStatuses': 'Alle statussen',
    'devDep.pending': 'In afwachting',
    'devDep.accepted': 'Geaccepteerd',
    'devDep.refused': 'Geweigerd',
    'devDep.depositPaid': 'Aanbetaling gedaan',
    'devDep.fullyPaid': 'Betaald',
    'devDep.stats': 'Statistieken',
    'devDep.revenues': 'Inkomsten',
    'devDep.activity30d': 'Activiteit van de afgelopen 30 dagen',
    'devDep.remind': 'Herinnering sturen',
    'devDep.remindConfirm': 'Herinnering sturen naar klanten met offertes die al meer dan 3 dagen in afwachting zijn?',
    'devDep.noDevis': 'Geen offertes aangemaakt',
    'devDep.noResults': 'Geen resultaten',
    'devDep.bon': 'Bestelbon',
    'devDep.facture': 'Factuur',
    'devDep.emailSent': 'E-mail verstuurd op',
    'devDep.reminderSent': 'Herinnering verstuurd op',
    // Reparations
    'rep.title': 'Reparaties',
    'rep.search': 'Reparatie zoeken...',
    'rep.new': 'Nieuwe reparatie',
    'rep.deviceRef': 'Toestel ref.',
    'rep.brand': 'Merk',
    'rep.model': 'Model',
    'rep.problem': 'Probleem',
    'rep.technician': 'Technicus',
    'rep.timeline': 'Tijdlijn',
    // Commandes
    'cmd.title': 'Bestellingen',
    'cmd.search': 'Bestelling zoeken...',
    'cmd.piece': 'Onderdeel',
    'cmd.supplier': 'Leverancier',
    'cmd.deposit': 'Aanbetaling',
    'cmd.remaining': 'Resterend bedrag',
    // Clients
    'clients.title': 'Klanten',
    'clients.search': 'Klant zoeken...',
    'clients.name': 'Naam',
    'clients.address': 'Adres',
    'clients.addClient': 'Nieuwe klant',
    // Stock
    'stock.title': 'Voorraadbeheer',
    'stock.search': 'Artikel zoeken...',
    'stock.addArticle': 'Artikel toevoegen',
    'stock.category': 'Categorie',
    'stock.buyPrice': 'Inkoopprijs',
    'stock.sellPrice': 'Verkoopprijs',
    'stock.available': 'Beschikbaar',
    // Dashboard
    'dash.title': 'Dashboard',
    'dash.openCaisse': 'Kassa openen',
    'dash.closeCaisse': 'Kassa sluiten',
    'dash.todaySales': 'Verkopen vandaag',
    'dash.monthSales': 'Verkopen van de maand',
    'dash.activeRepairs': 'Actieve reparaties',
    'dash.pendingOrders': 'Bestellingen in afwachting',
    // Login
    'login.title': 'Inloggen',
    'login.username': 'Gebruikersnaam',
    'login.password': 'Toegangscode',
    'login.submit': 'Inloggen',
    'login.clientAccess': 'Klanttoegang',
    'login.staffAccess': 'Personeeltoegang',
    // Language
    'lang.select': 'Taal',
    // Client Portal
    'client.space': 'Klantenzone',
    'client.repairs': 'Reparaties',
    'client.boutique': 'Winkel',
    'client.orders': 'Bestellingen',
    'client.messages': 'Berichten',
    'client.devis': 'Offertes',
    'client.trackRepairs': 'Volg uw reparaties',
    'client.noRepairs': 'Geen lopende reparaties',
    'client.trackOrders': 'Volg uw bestellingen',
    'client.noOrders': 'Geen lopende bestellingen',
    'client.shop': 'Online winkel',
    'client.noProducts': 'Geen producten beschikbaar',
    'client.addToCart': 'Toevoegen aan winkelwagen',
    'client.yourMessages': 'Uw berichten',
    'client.noMessages': 'Geen berichten',
    'client.send': 'Versturen',
    'client.brand': 'Merk',
    'client.model': 'Model',
    'client.problem': 'Probleem',
    'client.status': 'Status',
    'client.deposit': 'Aanbetaling',
    'client.remaining': 'Resterend bedrag',
    'client.total': 'Totaal',
    'client.timeline': 'Tijdlijn',
    'client.noDevis': 'Nog geen offertes',
    'client.acceptRefuse': 'Accepteren / Weigeren',
    'client.pay': 'Betalen',
    // Landing
    'landing.mobileRepair': 'Mobiele reparatie in Frans-Guyana',
    'landing.staffSpace': 'PERSONEELSZONE',
    'landing.staffDesc': 'Toegang technisch team',
    'landing.clientSpace': 'KLANTENZONE',
    'landing.clientDesc': 'Reparatieopvolging',
    'landing.businessSpace': 'BEDRIJFSZONE',
    'landing.businessDesc': 'B2B-portaal',
    'landing.contact': 'Contact',
    'landing.callWhatsapp': 'Bellen & WhatsApp',
    'landing.writeUs': 'Schrijf ons rechtstreeks',
    'landing.hours': 'Openingsuren',
    'landing.legal': 'Juridische informatie',
    'landing.capital': 'met een kapitaal van',
    'landing.headquarters': 'Hoofdkantoor',
    'landing.allRights': 'Alle rechten voorbehouden',
    'landing.heroSubtitle': 'Uw specialist voor mobiele reparatie in Frans-Guyana',
    'landing.mondayFriday': 'Maandag - Vrijdag',
    'landing.saturday': 'Zaterdag',
    'landing.sunday': 'Zondag',
    'landing.closed': 'Gesloten',
    'landing.companyType': 'Vereenvoudigde naamloze vennootschap (SAS)',
    'landing.openMaps': 'Openen in Maps',
    'landing.rcs': 'KBO',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Verkooppunt',
    // Login extra
    'login.clientSpace': 'Klantenzone',
    'login.businessSpace': 'Bedrijfszone',
    'login.staffSpace': 'Personeelszone',
    'login.connectYou': 'Inloggen',
    'login.phoneNumber': 'Telefoonnummer',
    'login.proEmail': 'Professioneel e-mail',
    'login.pin': 'PIN-code (4 of 6 cijfers)',
    'login.pinHint': 'Voer uw code in via het toetsenbord of het numerieke toetsenblok.',
    'login.connecting': 'Verbinden...',
    'login.connect': 'Inloggen',
    'login.noAccount': 'Nog geen account?',
    'login.createAccount': 'Account aanmaken',
    'login.forgotPwd': 'Wachtwoord vergeten?',
    'login.notRegistered': 'Nog niet geregistreerd?',
    'login.businessRegister': 'Bedrijfsregistratie',
    'login.secure': 'Veilig inloggen',
    'login.caricature': 'Ik maak mijn karikatuur',
    'login.backHome': 'Terug naar startpagina',
    'login.wrongCredentials': 'Onjuiste inloggegevens',
    'login.pinError': 'De PIN-code moet 4 of 6 cijfers bevatten',
    'login.b2bPassword': 'Wachtwoord',
    'login.b2bPlaceholder': 'Uw wachtwoord',
    'login.yourId': 'Uw gebruikersnaam',
    // Dashboard extra
    'dash.hello': 'Hallo',
    'dash.loggedAs': 'Ingelogd als',
    'dash.caisseOpen': 'Kassa open',
    'dash.closeCaisseReminder': 'Vergeet niet de kassa te sluiten',
    'dash.noCaisse': 'Geen kassa open',
    'dash.openCaisseTitle': 'Kassa openen',
    'dash.openTotal': 'Openingsbedrag',
    'dash.opening': 'Openen...',
    'dash.open': 'Openen',
    'dash.searchPlaceholder': 'Zoeken op referentie, klant, telefoon...',
    'dash.noResults': 'Geen resultaten gevonden',
    'dash.today': 'Vandaag',
    'dash.thisMonth': 'Deze maand',
    'dash.completed': 'Afgerond',
    'dash.repairsSub': 'reparaties',
    'dash.inProgress': 'In behandeling',
    'dash.waitingParts': 'wachtend op onderdelen incl.',
    'dash.registeredMonth': 'deze maand geregistreerd',
    'dash.statsTitle': 'Statistieken & Analyses',
    'dash.statsDesc': 'Omzet, reparaties, B2B, klanten',
    'dash.brandsModelsLabel': 'Merken & Modellen',
    'dash.brandsModelsDesc': 'Apparaatcatalogus beheren',
    'dash.b2bPaymentsLabel': 'B2B-betalingen',
    'dash.b2bPaymentsDesc': 'Factuur- en betalingsopvolging',
    'dash.stockAlerts': 'Voorraadwaarschuwingen',
    'dash.lowStock': 'producten met lage voorraad',
    'dash.outOfStock': 'niet op voorraad',
    'dash.recentRepairs': 'Laatste reparaties',
    'dash.noClient': 'Zonder klant',
    'dash.unclosedTitle': 'Kassa niet gesloten',
    'dash.unclosedNotClosed': 'is niet gesloten',
    'dash.contactAdmin': 'Neem contact op met een beheerder om deze te sluiten voordat u verdergaat.',
    'dash.mustClose': 'U moet deze sluiten voordat u kunt doorwerken.',
    'dash.forceClose': 'Geforceerd sluiten',
    'dash.closing': 'Sluiten...',
    'dash.closeNormal': 'Normaal sluiten',
    'dash.noCaisseToday': 'Er is vandaag geen kassa open.',
    'dash.openQuestion': 'Wilt u de kassa nu openen?',
    'dash.dontOpen': 'Niet openen (doorgaan)',
    'dash.salesBlocked': 'Verkopen zijn geblokkeerd zolang de kassa niet open is.',
    'dash.calculation': 'Berekening',
    'dash.repairs': 'Reparaties',
    'dash.addDevice': 'Toevoegen',
    'dash.clients': 'Klanten',
    'dash.openedBy': 'geopend door',
    'dash.unknown': 'onbekend',
    'dash.forceCloseConfirm': 'Kassa geforceerd sluiten van',
    'dash.errorForceClose': 'Fout bij geforceerd sluiten',
    'dash.errorOpenCaisse': 'Fout bij het openen van de kassa',
    // Devis Accept
    'devisAccept.error': 'Fout',
    'devisAccept.notFound': 'Offerte niet gevonden',
    'devisAccept.refused': 'Offerte geweigerd',
    'devisAccept.refusedMsg': 'U heeft de offerte geweigerd',
    'devisAccept.thanks': 'Bedankt voor uw terugkoppeling.',
    'devisAccept.accepted': 'Offerte geaccepteerd!',
    'devisAccept.acceptedMsg': 'Bedankt voor het accepteren van de offerte',
    'devisAccept.bonCommande': 'Bestelbon',
    'devisAccept.facture': 'Factuur',
    'devisAccept.emailSent': 'Een e-mail met uw bestelbon, validatiecode en inloggegevens is verstuurd.',
    'devisAccept.proceedPayment': 'Naar betaling',
    'devisAccept.paymentMsg': 'Om uw bestelling af te ronden, maak een aanbetaling of volledige betaling:',
    'devisAccept.deposit50': 'Aanbetaling 50%',
    'devisAccept.fullPayment': 'Volledige betaling',
    'devisAccept.alreadyAccepted': 'Deze offerte is al geaccepteerd.',
    'devisAccept.alreadyRefused': 'Deze offerte is geweigerd.',
    'devisAccept.statusMsg': 'Offertestatus',
    'devisAccept.payDeposit': 'Aanbetaling 50% betalen',
    'devisAccept.homeRepairQuote': 'Offerte reparatie ter plaatse',
    'devisAccept.hello': 'Hallo',
    'devisAccept.findBelow': 'Hieronder vindt u de details van uw offerte:',
    'devisAccept.designation': 'Aanduiding',
    'devisAccept.travelFee': 'Verplaatsingskosten',
    'devisAccept.tvaNote': 'BTW niet van toepassing, art. 293B CGI. Offerte 30 dagen geldig.',
    'devisAccept.refuse': 'Weigeren',
    'devisAccept.accept': 'Offerte accepteren',
    'devisAccept.confirmRefuse': 'Weet u zeker dat u deze offerte wilt weigeren?',
    // Payment
    'payment.secure': 'Veilige betaling',
    'payment.error': 'Fout',
    'payment.backToDevis': 'Terug naar offerte',
    'payment.notAccepted': 'Offerte niet geaccepteerd',
    'payment.mustAcceptFirst': 'U moet eerst de offerte accepteren voordat u kunt betalen.',
    'payment.viewDevis': 'Offerte bekijken',
    'payment.fullyPaid': 'Factuur volledig betaald',
    'payment.alreadyPaid': 'is al volledig betaald.',
    'payment.accessClient': 'Toegang tot uw klantenzone',
    'payment.deposit50': 'Aanbetaling 50%',
    'payment.fullPayment': 'Volledige betaling',
    'payment.devis': 'Offerte',
    'payment.client': 'Klant',
    'payment.totalDevis': 'Totaal offerte',
    'payment.alreadyPaidAmount': 'Reeds betaald',
    'payment.remaining': 'Resterend bedrag',
    'payment.depositPercent': 'Aanbetaling (50%)',
    'payment.amountToPay': 'Te betalen bedrag',
    'payment.pay': 'Betalen',
    'payment.redirecting': 'Doorverwijzen naar Stripe...',
    'payment.securedBy': 'Veilige betaling via Stripe',
    'payment.urlNotAvailable': 'Betaal-URL niet beschikbaar',
    'payment.creationError': 'Fout bij het aanmaken van de betaling',
    // Payment success
    'paySuccess.confirmed': 'Betaling bevestigd!',
    'paySuccess.paymentFor': 'Uw betaling voor offerte',
    'paySuccess.registered': 'is succesvol geregistreerd.',
    'paySuccess.depositRegistered': 'Aanbetaling geregistreerd!',
    'paySuccess.depositFor': 'Uw aanbetaling voor offerte',
    'paySuccess.depositDone': 'is geregistreerd.',
    'paySuccess.checking': 'Verificatie...',
    'paySuccess.pleaseWait': 'We controleren uw betaling, even geduld.',
    'paySuccess.waitingConfirm': 'Wachten op bevestiging',
    'paySuccess.processing': 'Uw betaling wordt verwerkt. U ontvangt een bevestigings-e-mail.',
    'paySuccess.totalInvoice': 'Totaal factuur',
    'paySuccess.amountPaid': 'Betaald bedrag',
    'paySuccess.remaining': 'Resterend bedrag',
    'paySuccess.payRemaining': 'Rest betalen',
    'paySuccess.loginClient': 'Log in op uw klantenzone',
    // Registration
    'register.clientTitle': 'Klantaccount aanmaken',
    'register.fullName': 'Volledige naam',
    'register.phone': 'Telefoon',
    'register.email': 'E-mail (optioneel)',
    'register.address': 'Adres (optioneel)',
    'register.pin': 'PIN-code (4 of 6 cijfers)',
    'register.confirmPin': 'PIN-code bevestigen',
    'register.creating': 'Aanmaken...',
    'register.createAccount': 'Mijn account aanmaken',
    'register.alreadyAccount': 'Al een account?',
    'register.login': 'Inloggen',
    'register.backHome': 'Terug naar startpagina',
    'register.pinError': 'De PIN-code moet 4 of 6 cijfers bevatten',
    'register.pinNoMatch': 'De PIN-codes komen niet overeen',
    'register.pinMinLength': 'De PIN-code moet minstens 4 cijfers bevatten',
    // B2B Registration
    'b2bRegister.title': 'Bedrijfsregistratie',
    'b2bRegister.subtitle': 'Maak uw professioneel account aan',
    'b2bRegister.companyName': 'Bedrijfsnaam',
    'b2bRegister.managerName': 'Naam van de beheerder',
    'b2bRegister.proEmail': 'Professioneel e-mail',
    'b2bRegister.phone': 'Telefoon',
    'b2bRegister.address': 'Adres',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Wachtwoord',
    'b2bRegister.confirmPassword': 'Wachtwoord bevestigen',
    'b2bRegister.kbis': 'KBIS-uittreksel (PDF)',
    'b2bRegister.kbisDesc': 'Upload uw KBIS-uittreksel of bewijsstuk (PDF)',
    'b2bRegister.dropFile': 'Klik of sleep uw bestand hier',
    'b2bRegister.creating': 'Registratie bezig...',
    'b2bRegister.submit': 'Registreren',
    'b2bRegister.success': 'Registratie geslaagd!',
    'b2bRegister.successMsg': 'Uw bedrijfsaccount wordt gevalideerd. U ontvangt een bevestigings-e-mail.',
    'b2bRegister.goLogin': 'Naar inloggen',
    'b2bRegister.fillAll': 'Vul alle verplichte velden in',
    'b2bRegister.siretError': 'Het SIRET moet 14 cijfers bevatten',
    'b2bRegister.pwdNoMatch': 'De wachtwoorden komen niet overeen',
    'b2bRegister.pwdMinLength': 'Het wachtwoord moet minstens 6 tekens bevatten',
    'b2bRegister.kbisRequired': 'Upload uw KBIS-uittreksel',
    'b2bRegister.alreadyAccount': 'Al geregistreerd?',
    // Reset password
    'reset.forgotTitle': 'Wachtwoord vergeten',
    'reset.forgotDesc': 'Ontvang een resetlink via e-mail',
    'reset.enterEmail': 'Voer uw e-mail in',
    'reset.emailSent': 'E-mail verstuurd',
    'reset.emailSentMsg': 'Als er een account bestaat met dit adres, ontvangt u een e-mail met een link om uw wachtwoord te resetten.',
    'reset.linkValid': 'De link is 1 uur geldig.',
    'reset.backLogin': 'Terug naar inloggen',
    'reset.clientEmail': 'E-mailadres van uw account',
    'reset.sending': 'Versturen...',
    'reset.sendLink': 'Resetlink versturen',
    'reset.newPwdTitle': 'Nieuw wachtwoord',
    'reset.newPwdDesc': 'Kies uw nieuw wachtwoord',
    'reset.newPwd': 'Nieuw wachtwoord',
    'reset.confirmPwd': 'Wachtwoord bevestigen',
    'reset.resetting': 'Resetten...',
    'reset.resetPwd': 'Wachtwoord resetten',
    'reset.pwdReset': 'Wachtwoord gereset',
    'reset.pwdResetMsg': 'Uw wachtwoord is succesvol gewijzigd.',
    'reset.pwdMinLength': 'Het wachtwoord moet minstens 4 tekens bevatten',
    'reset.pwdNoMatch': 'De wachtwoorden komen niet overeen',
    'reset.error': 'Er is een fout opgetreden',
    // B2B Dashboard
    'b2b.welcome': 'Welkom',
    'b2b.newRepair': 'Nieuwe reparatie',
    'b2b.registerDevice': 'Toestel registreren',
    'b2b.myRepairs': 'Mijn reparaties',
    'b2b.viewAll': 'Alle reparaties bekijken',
    'b2b.recentRepairs': 'Laatste reparaties',
    'b2b.noRepairs': 'Geen reparaties',
    'b2b.repairRegistered': 'Reparatie geregistreerd',
    'b2b.reference': 'Referentie',
    'b2b.viewDetails': 'Details bekijken',
    'b2b.anotherRepair': 'Nieuwe reparatie',
    'b2b.deviceInfo': 'Toestelinformatie',
    'b2b.brand': 'Merk',
    'b2b.model': 'Model',
    'b2b.backGlass': 'Achterglas',
    'b2b.backGlassBroken': 'Achterglas gebroken',
    'b2b.backGlassOk': 'Achterglas intact',
    'b2b.providePart': 'Ik lever het onderdeel',
    'b2b.partByShop': 'Het onderdeel wordt geleverd door R.E.Mobiles',
    'b2b.lockCode': 'Ontgrendelingscode',
    'b2b.lockTypeCode': 'Code (cijfers/letters)',
    'b2b.lockTypeSchema': 'Patroon',
    'b2b.problem': 'Probleem / Beschrijving',
    'b2b.brokenParts': 'Defecte onderdelen',
    'b2b.deliveryMethod': 'Leveringsmethode',
    'b2b.inStore': 'In de winkel',
    'b2b.inStoreDesc': 'Afgifte in de winkel',
    'b2b.postal': 'Postverzending',
    'b2b.postalDesc': 'Met trackingnummer',
    'b2b.pickup': 'Ophaling',
    'b2b.pickupDesc': 'Wij komen het ophalen',
    'b2b.trackingNumber': 'Trackingnummer',
    'b2b.pickupAddress': 'Ophaaladres',
    'b2b.devicePhotos': "Foto's van het toestel",
    'b2b.addPhotos': "Klik om foto's toe te voegen",
    'b2b.additionalNotes': 'Extra opmerkingen',
    'b2b.submitting': 'Versturen...',
    'b2b.submitRepair': 'Reparatie registreren',
    'b2b.brandModelRequired': 'Merk en model zijn verplicht',
    'b2b.noRepairFound': 'Geen reparatie gevonden',
    'b2b.allStatus': 'Alle',
    'b2b.documents': 'Documenten & Facturen',
    'b2b.documentsDesc': 'Valideer uw bestelbonnen en download facturen',
    'b2b.pendingValidation': 'Te valideren bestelbonnen',
    'b2b.enterCode': 'Voer de per e-mail ontvangen code in om elke bestelbon te valideren.',
    'b2b.validate': 'Valideren',
    'b2b.invoices': 'Facturen',
    'b2b.noInvoices': 'Geen facturen beschikbaar',
    'b2b.device': 'Toestel',
    'b2b.amount': 'Bedrag',
    'b2b.date': 'Datum',
    'b2b.actions': 'Acties',
    'b2b.paid': 'Betaald',
    'b2b.repairAccepted': 'Reparatie geaccepteerd door het personeel',
    'b2b.repairRefused': 'Reparatie geweigerd door het personeel',
    'b2b.orderValidated': 'Bestelbon gevalideerd',
    'b2b.noPhotos': "Geen foto's",
    'b2b.history': 'Geschiedenis',
    'b2b.repairPrice': 'Reparatieprijs',
    'b2b.diagPrice': 'Diagnoseprijs',
    'b2b.priceWaiting': 'In afwachting - wordt bepaald door R.E.Mobiles',
    'b2b.createdOn': 'Aangemaakt op',
    'b2b.clear': 'Wissen',
    'b2b.thisMonth': 'Deze maand',
    'b2b.waitingReception': 'Wacht op ontvangst',
    'b2b.received': 'Ontvangen',
    'b2b.inProgress': 'In behandeling',
    'b2b.waitingParts': 'Wacht op onderdelen',
    'b2b.completed': 'Afgerond',
    'b2b.delivered': 'Geleverd',
    // B2B Devis
    'b2bDevis.title': 'Offertes verplaatsing',
    'b2bDevis.pending': 'in afwachting',
    'b2bDevis.noDevis': 'Geen offertes',
    'b2bDevis.noDevisDesc': 'U heeft momenteel geen verplaatsingsoffertes.',
    'b2bDevis.travelFee': 'Verplaatsingskosten',
    'b2bDevis.validationCode': 'Validatiecode',
    'b2bDevis.codeHint': 'Voer de 6-cijferige code in die u per e-mail heeft ontvangen.',
    'b2bDevis.acceptFirst': 'Accepteer eerst de offerte om deze te kunnen valideren.',
    'b2bDevis.payDeposit': 'Aanbetaling 50% betalen',
    'b2bDevis.payFull': 'Totaal betalen',
    'b2bDevis.payRemaining': 'Rest betalen',
    'b2bDevis.alreadyPaid': 'Reeds betaald',
    'b2bDevis.remaining': 'Resterend bedrag',
    'b2bDevis.invoiceDownload': 'Factuur downloaden',
    'b2bDevis.orderDownload': 'Bestelbon downloaden',
    'b2bDevis.quoteDownload': 'Offerte downloaden',
    // Admin Site Settings
    'adminSettings.title': 'Startpagina',
    'adminSettings.preview': 'Voorbeeld',
    'adminSettings.saving': 'Opslaan...',
    'adminSettings.save': 'Opslaan',
    'adminSettings.saved': 'Opgeslagen!',
    'adminSettings.error': 'Fout',
    'adminSettings.heroSection': 'Hero / Koptekst',
    'adminSettings.mainTitle': 'Hoofdtitel',
    'adminSettings.subtitle': 'Ondertitel',
    'adminSettings.accentColor': 'Accentkleur (hex)',
    'adminSettings.bgImage': 'Achtergrondafbeelding',
    'adminSettings.change': 'Wijzigen',
    'adminSettings.companyInfo': 'Bedrijfsinformatie',
    'adminSettings.companyName': 'Bedrijfsnaam',
    'adminSettings.companyType': 'Type (SAS, SARL...)',
    'adminSettings.capital': 'Kapitaal',
    'adminSettings.rcs': 'KBO',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Hoofdkantoor',
    'adminSettings.salesPoint': 'Verkooppunt',
    'adminSettings.contactHours': 'Contact & Openingsuren',
    'adminSettings.phone': 'Telefoon',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'E-mail',
    'adminSettings.googleMaps': 'Google Maps zoekopdracht',
    'adminSettings.gallery': 'Fotogalerij',
    'adminSettings.addImage': 'Afbeelding toevoegen',
    // Admin Database
    'adminDb.title': 'Databasebeheer',
    'adminDb.subtitle': 'Export, import en gegevensbeheer',
    'adminDb.accessDenied': 'Toegang geweigerd',
    'adminDb.adminOnly': 'Deze pagina is voorbehouden aan beheerders',
    'adminDb.clients': 'Klanten',
    'adminDb.users': 'Gebruikers',
    'adminDb.repairs': 'Reparaties',
    'adminDb.stockArticles': 'Voorraadartikelen',
    'adminDb.exportTitle': 'Database exporteren',
    'adminDb.exportDesc': 'Alle gegevens exporteren (klanten, gebruikers, voorraad, reparaties, verkopen) als JSON.',
    'adminDb.exportConfirm': 'Volledige database exporteren?',
    'adminDb.exportBtn': 'Volledige database exporteren',
    'adminDb.exportSuccess': 'Export geslaagd!',
    'adminDb.exportError': 'Fout bij het exporteren',
    'adminDb.importTitle': 'Database importeren',
    'adminDb.importDesc': 'Een JSON-bestand importeren om gegevens te herstellen of te migreren.',
    'adminDb.fileSelected': 'Bestand geselecteerd',
    'adminDb.uploading': 'Bestand uploaden...',
    'adminDb.importDone': 'Import voltooid!',
    'adminDb.importSuccess': 'Import geslaagd!',
    'adminDb.importError': 'Fout bij het importeren',
    'adminDb.importClientsBtn': 'Klanten importeren',
    'adminDb.importFullBtn': 'Volledige import',
    'adminDb.importWarning': 'De volledige import vervangt bestaande gegevens',
    'adminDb.importConfirm': 'LET OP: Deze actie vervangt bestaande gegevens. Doorgaan?',
    'adminDb.importClientsConfirm': 'Klanten importeren? Accounts worden aangemaakt met het telefoonnummer als gebruikersnaam.',
    'adminDb.selectFile': 'Selecteer een bestand',
    'adminDb.selectFileClients': 'Selecteer een JSON-bestand met klanten',
    'adminDb.logsTitle': 'Operatielogboek',
    'adminDb.noLogs': 'Geen operaties geregistreerd',
    // Admin B2B
    'adminB2b.title': 'B2B-beheer',
    'adminB2b.home': 'Startpagina',
    'adminB2b.monthlyRecap': 'Maandelijkse samenvatting',
    'adminB2b.sending': 'Versturen...',
    'adminB2b.search': 'Zoeken...',
    'adminB2b.recapTitle': 'Resultaat van de maandelijkse samenvatting',
    'adminB2b.recapSent': 'Verstuurd',
    'adminB2b.recapSkipped': 'Geen reparaties',
    'adminB2b.recapError': 'Fout',
    'adminB2b.companies': 'Bedrijven',
    'adminB2b.b2bRepairs': 'B2B-reparaties',
    'adminB2b.paymentHistory': 'Betalingsgeschiedenis',
    'adminB2b.all': 'Alle',
    'adminB2b.pending': 'In afwachting',
    'adminB2b.validated': 'Gevalideerd',
    'adminB2b.refused': 'Geweigerd',
    'adminB2b.suspended': 'Opgeschort',
    'adminB2b.noCompany': 'Geen bedrijf gevonden',
    'adminB2b.phone': 'Telefoon',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Adres',
    'adminB2b.registeredOn': 'Geregistreerd op',
    'adminB2b.validatedBy': 'Gevalideerd door',
    'adminB2b.downloadKbis': 'KBIS downloaden',
    'adminB2b.validate': 'Valideren',
    'adminB2b.refuse': 'Weigeren',
    'adminB2b.suspend': 'Opschorten',
    'adminB2b.confirmValidate': 'Wilt u dit bedrijf valideren?',
    'adminB2b.confirmRefuse': 'Wilt u dit bedrijf weigeren?',
    'adminB2b.confirmSuspend': 'Wilt u dit bedrijf opschorten?',
    'adminB2b.pendingReception': 'Wacht op ontvangst',
    'adminB2b.confirmReception': 'Ontvangst bevestigen',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Bedrijf',
    'adminB2b.brandModel': 'Merk / Model',
    'adminB2b.problem': 'Probleem',
    'adminB2b.delivery': 'Levering',
    'adminB2b.price': 'Prijs',
    'adminB2b.status': 'Status',
    'adminB2b.actions': 'Acties',
    'adminB2b.noRepairs': 'Geen B2B-reparaties gevonden',
    'adminB2b.postal': 'Post',
    'adminB2b.pickup': 'Ophaling',
    'adminB2b.inStore': 'Winkel',
    'adminB2b.changeStatus': 'Status wijzigen',
    'adminB2b.setPrice': 'Prijs bepalen',
    'adminB2b.repairPrice': 'Reparatieprijs',
    'adminB2b.diagPrice': 'Diagnoseprijs',
    'adminB2b.locked': 'Vergrendeld (betaald)',
    'adminB2b.total': 'Totaal',
    'adminB2b.existingInvoices': 'Bestaande facturen',
    'adminB2b.diagnostic': 'Diagnose',
    'adminB2b.repair': 'Reparatie',
    'adminB2b.combined': 'Gecombineerd',
    'adminB2b.paidMethod': 'Betaald',
    'adminB2b.awaitingPayment': 'In afwachting',
    'adminB2b.markPaid': 'Betaald',
    'adminB2b.finalize': 'Facturering afronden',
    'adminB2b.backGlassBroken': 'Achterglas gebroken',
    'adminB2b.clientPart': 'Klantonderdeel',
    'adminB2b.bcValidated': 'BB gevalideerd',
    'adminB2b.invoiceCancelled': 'Factuur geannuleerd',
    'adminB2b.monthPrompt': 'Maand (1-12)? Laat leeg voor de vorige maand:',
    'adminB2b.yearPrompt': 'Jaar?',
    'adminB2b.paymentMethodPrompt': 'Betaalmethode?',
    'adminB2b.filterCompany': 'Bedrijf',
    'adminB2b.filterDateStart': 'Startdatum',
    'adminB2b.filterDateEnd': 'Einddatum',
    'adminB2b.filter': 'Filteren',
    'adminB2b.clearFilter': 'Wissen',
    'adminB2b.totalCollected': 'Totaal geïnd',
    'adminB2b.payments': 'betaling(en)',
    'adminB2b.payHistoryTitle': 'B2B-betalingsgeschiedenis',
    'adminB2b.noPayments': 'Geen B2B-betalingen geregistreerd',
    'adminB2b.invoice': 'Factuur',
    // Users Management
    'users.title': 'Gebruikersbeheer',
    'users.count': 'gebruiker(s)',
    'users.new': 'Nieuwe gebruiker',
    'users.edit': 'Gebruiker bewerken',
    'users.username': 'Gebruikersnaam',
    'users.password': 'Wachtwoord',
    'users.newPassword': 'Nieuw wachtwoord (leeg laten om niet te wijzigen)',
    'users.role': 'Rol',
    'users.roleAdmin': 'Beheerder',
    'users.roleUser': 'Verkoper',
    'users.roleTech': 'Technicus',
    'users.status': 'Status',
    'users.active': 'Actief',
    'users.inactive': 'Inactief',
    'users.createdAt': 'Aangemaakt op',
    'users.noUsers': 'Geen gebruikers',
    'users.accessDenied': 'Alleen voor beheerders',
    'users.deleteConfirm': 'Deze gebruiker verwijderen?',
    // Clients (extra keys)
    'clients.manage': 'Klantenbeheer',
    'clients.total': 'klanten in totaal',
    'clients.add': 'Toevoegen',
    'clients.noClients': 'Geen klant gevonden',
    'clients.type': 'Type',
    'clients.discount': 'Korting',
    'clients.account': 'Account',
    'clients.sent': 'Verstuurd',
    'clients.activeAccount': 'Actief',
    'clients.noEmail': 'Geen e-mail',
    'clients.editClient': 'Klant bewerken',
    'clients.newClient': 'Nieuwe klant',
    'clients.company': 'Bedrijf',
    'clients.clientType': 'Type klant',
    'clients.individual': 'Particulier',
    'clients.business': 'Bedrijf',
    'clients.discountPct': 'Korting (%)',
    'clients.deleteConfirm': 'Deze klant verwijderen?',
    'clients.page': 'Pagina',
    // Stats
    'stats.title': 'Statistieken & Analyses',
    'stats.revenue': 'Omzet',
    'stats.repairs': 'Reparaties',
    'stats.b2b': 'B2B',
    'stats.clients': 'Klanten',
    'stats.back': 'Terug',
    'stats.monthlyRevenue': 'Maandelijkse omzet',
    'stats.revenueByType': 'Omzet per type',
    'stats.revenueByPayment': 'Omzet per betaalmethode',
    'stats.totalRevenue': 'Totale omzet (12 maanden)',
    'stats.repairsByStatus': 'Per status',
    'stats.repairsByBrand': 'Per merk',
    'stats.topModels': 'Top modellen',
    'stats.monthly': 'Maandelijkse evolutie',
    'stats.totalRepairs': 'Totale reparaties',
    'stats.avgRepairTime': 'Gemiddelde duur',
    'stats.completionRate': 'Voltooiingspercentage',
    'stats.b2bCompanies': 'B2B-bedrijven',
    'stats.b2bRepairs': 'B2B-reparaties',
    'stats.b2bRevenue': 'B2B-omzet',
    'stats.b2bByCompany': 'Per bedrijf',
    'stats.totalClients': 'Totale klanten',
    'stats.newThisMonth': 'Nieuw deze maand',
    'stats.withAccount': 'Met account',
    'stats.clientsByType': 'Per type',
    'stats.registrations': 'Maandelijkse registraties',
    'stats.noData': 'Geen gegevens',
    // Reparations (extra)
    'rep.manage': 'Reparatiebeheer',
    'rep.noRepairs': 'Geen reparatie gevonden',
    'rep.allStatuses': 'Alle statussen',
    'rep.imei': 'IMEI / Serienr.',
    'rep.client': 'Klant',
    'rep.phone': 'Tel.',
    'rep.date': 'Datum',
    'rep.deposit': 'Aanbetaling',
    'rep.printFiche': 'Formulier afdrukken',
    'rep.printEtiquette': 'Etiket afdrukken',
    'rep.deleteConfirm': 'Deze reparatie verwijderen?',
    'rep.addDeposit': 'Aanbetaling toevoegen',
    'rep.depositAmount': 'Aanbetalingsbedrag',
    'rep.paymentMode': 'Betaalmethode',
    'rep.depositHistory': 'Aanbetalingsgeschiedenis',
    'rep.totalDeposits': 'Totale aanbetalingen',
    'rep.changeStatus': 'Status wijzigen',
    'rep.notes': 'Interne notities',
    'rep.sendChat': 'Bericht versturen',
    'rep.noTimeline': 'Geen gebeurtenissen',
    // Commandes (extra)
    'cmd.manage': 'Bestellingenbeheer',
    'cmd.noOrders': 'Geen bestelling gevonden',
    'cmd.allStatuses': 'Alle statussen',
    'cmd.ordered': 'Besteld',
    'cmd.received': 'Ontvangen',
    'cmd.cancelled': 'Geannuleerd',
    'cmd.status': 'Status',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'Nieuwe bestelling',
    'cmd.editOrder': 'Bestelling bewerken',
    'cmd.deleteConfirm': 'Deze bestelling verwijderen?',
    // Stock (extra)
    'stock.manage': 'Voorraadbeheer',
    'stock.noItems': 'Geen artikel gevonden',
    'stock.barcode': 'Barcode',
    'stock.reference': 'Referentie',
    'stock.alert': 'Waarschuwing',
    'stock.lowStockAlert': 'Lage voorraad',
    'stock.addForm': 'Artikel toevoegen',
    'stock.editForm': 'Artikel bewerken',
    'stock.deleteConfirm': 'Dit artikel verwijderen?',
    // Historique
    'hist.title': 'Verkoopgeschiedenis',
    'hist.search': 'Verkoop zoeken...',
    'hist.noSales': 'Geen verkoop gevonden',
    'hist.ref': 'Ref.',
    'hist.client': 'Klant',
    'hist.amount': 'Bedrag',
    'hist.payment': 'Betaling',
    'hist.date': 'Datum',
    'hist.articles': 'Artikelen',
    'hist.refund': 'Terugbetalen',
    'hist.refundConfirm': 'Deze verkoop terugbetalen?',
    // Paiements
    'pay.title': 'Online betalingen',
    'pay.search': 'Zoeken...',
    'pay.noPayments': 'Geen betaling gevonden',
    'pay.ref': 'Referentie',
    'pay.client': 'Klant',
    'pay.amount': 'Bedrag',
    'pay.status': 'Status',
    'pay.date': 'Datum',
    'pay.type': 'Type',
    // Caisse
    'caisse.title': 'Kassageschiedenis',
    'caisse.noCaisse': 'Geen kassa gevonden',
    'caisse.openedBy': 'Geopend door',
    'caisse.openingAmount': 'Openingsbedrag',
    'caisse.closingAmount': 'Sluitingsbedrag',
    'caisse.sales': 'Verkopen',
    'caisse.openDate': 'Opening',
    'caisse.closeDate': 'Sluiting',
    // Notes
    'notes.title': 'Notities',
    'notes.new': 'Nieuwe notitie',
    'notes.noNotes': 'Geen notities',
    'notes.deleteConfirm': 'Deze notitie verwijderen?',
    // Etiquettes
    'labels.title': 'Etiketten',
    'labels.search': 'Zoeken...',
    'labels.print': 'Afdrukken',
    'labels.selectAll': 'Alles selecteren',
    'labels.noLabels': 'Geen etiketten',
    // Calcul Prix
    'calc.title': 'Prijsberekening',
    'calc.searchDevice': 'Toestel zoeken...',
    'calc.selectRepair': 'Reparatie selecteren',
    'calc.generateQuote': 'Offerte genereren',
    'calc.generateInvoice': 'Factuur genereren',
    // Boutique
    'boutique.title': 'Winkelbestellingen',
    'boutique.noOrders': 'Geen bestellingen',
    'boutique.orderRef': 'Bestelnr.',
    'boutique.clientName': 'Klant',
    'boutique.total': 'Totaal',
    'boutique.status': 'Status',
    // Chat
    'chat.title': 'Berichten',
    'chat.noConversations': 'Geen gesprekken',
    'chat.typeMessage': 'Typ uw bericht...',
    // Brands & Models
    'brands.title': 'Merken & Modellen',
    'brands.addBrand': 'Merk toevoegen',
    'brands.addModel': 'Model toevoegen',
    'brands.noBrands': 'Geen merken',
    'brands.deleteConfirm': 'Dit merk verwijderen?',
    // Remcaches
    'remcaches.title': 'Cache-resets',
    'remcaches.noItems': 'Geen artikelen',
    // Close Caisse
    'closeCaisse.title': 'Kassasluiting',
    'closeCaisse.countCoins': 'Contant geld tellen',
    'closeCaisse.theoreticalTotal': 'Theoretisch totaal',
    'closeCaisse.actualTotal': 'Werkelijk totaal',
    'closeCaisse.difference': 'Verschil',
    'closeCaisse.close': 'Kassa sluiten',
    'closeCaisse.closing': 'Sluiten...',
    // Client Passwords
    'clientPwd.title': 'Wachtwoorden klanten',
    'clientPwd.search': 'Klant zoeken...',
    'clientPwd.noClients': 'Geen klant gevonden',
    'clientPwd.generatePin': 'PIN genereren',
    'clientPwd.sendByEmail': 'Per e-mail versturen',
    // B2B Payments
    'b2bPay.title': 'B2B-betalingen',
    'b2bPay.noPayments': 'Geen betalingen',
    // Reparation Form
    'repForm.title': 'Toestel toevoegen',
    'repForm.editTitle': 'Reparatie bewerken',
    'repForm.brand': 'Merk',
    'repForm.model': 'Model',
    'repForm.imei': 'IMEI / Serienr.',
    'repForm.lockCode': 'Ontgrendelingscode',
    'repForm.problem': 'Vastgesteld probleem',
    'repForm.client': 'Klant',
    'repForm.technician': 'Toegewezen technicus',
    'repForm.price': 'Reparatieprijs',
    'repForm.submit': 'Opslaan',
    'repForm.submitting': 'Opslaan...',
    'sumup.acceptOnlinePayment': 'Online betaling accepteren (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'De klant kan een SumUp-betalingslink aanvragen', 'sumup.requestLink': 'SumUp-betalingslink aanvragen', 'sumup.requestSent': 'Aanvraag verzonden! U ontvangt de link per e-mail.', 'sumup.alreadyRequested': 'Aanvraag al in behandeling.', 'sumup.onlinePayment': 'SumUp online betaling', 'sumup.receiveLink': 'Ontvang een veilige betalingslink per e-mail', 'sumup.linkRequested': 'Link aangevraagd', 'sumup.pendingRequests': 'SumUp link aanvragen', 'sumup.pending': 'in afwachting', 'sumup.pasteLinkHere': 'SumUp-link hier plakken...', 'sumup.send': 'Verzenden', 'sumup.linkSent': 'SumUp-link per e-mail naar klant verzonden!',
  };

export default nl;
